import { Component, inject, Input, OnInit, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { QuestionsService } from '../../services/questions.service';
import { QuestionLogEntry } from '../../models/question-log.model';

const ACTION_LABELS: Record<string, string> = {
  CREATE: 'أنشئ',
  UPDATE: 'عُدّل',
};

const ROLE_LABELS: Record<string, string> = {
  client: 'عميل',
  expert: 'خبير',
};

@Component({
  selector: 'app-change-log',
  standalone: false,
  templateUrl: './change-log.component.html',
  styleUrl: './change-log.component.scss',
})
export class ChangeLogComponent implements OnInit {
  @Input() questionId!: number;
  entries: QuestionLogEntry[] = [];

  private questionsService = inject(QuestionsService);
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.loadLogs();
  }

  loadLogs(): void {
    this.questionsService.getQuestionLogs(this.questionId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (response) => { this.entries = response.data || []; },
      error: () => { this.entries = []; },
    });
  }

  getActionLabel(entry: QuestionLogEntry): string {
    const actionLabel = ACTION_LABELS[entry.action] || entry.action;
    const roleLabel = this.getRoleLabel(entry.created_by?.role ?? null);
    return roleLabel ? `${actionLabel} بواسطة ${roleLabel}` : actionLabel;
  }

  getRoleLabel(role: string | null): string {
    return role ? ROLE_LABELS[role] || role : '';
  }
}
